import DialogTitle from '@material-ui/core/DialogTitle';
import { createStyles, withStyles } from '@material-ui/styles';
import * as React from 'react';
import { compose, pure } from 'recompose';
const styles = (theme) => createStyles({
    title: {
        fontSize: theme.font.size.big,
        fontWeight: theme.font.weight.bold,
        padding: '20px 20px 0px',
    },
});
const ModalTitle = (props) => {
    const { classes, children, testId = 'ModalTitle' } = props;
    return (React.createElement(DialogTitle, { disableTypography: true, "data-testid": testId, className: classes.title }, children));
};
const ComposedModalTitle = compose(withStyles(styles, { withTheme: true }), pure)(ModalTitle);
ComposedModalTitle.displayName = 'ModalTitle';
export default ComposedModalTitle;
//# sourceMappingURL=ModalTitle.js.map